import { withRouter } from 'react-router-dom';
import PaymentReceiptV2 from './PaymentReceipt-V2';

const connectedPage = withRouter(PaymentReceiptV2)

export default connectedPage;



// WEBPACK FOOTER //
// ./src/components/atomic/pages/Receipt/index.js